import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

import {
    SetAnalyticsUserSettingPropertiesCurrency,
    SetAnalyticsUserSettingPropertiesMetrics,
} from '@core/ngxs/actions/analytics-user-setting-properties.actions';
import { AnalyticsGeneralPropertiesHelpers } from '@core/ngxs/helpers/analytics-general-properties.helpers';

import { AnalyticsUserSettingPropertiesStateModel } from '../models/analytics-user-setting-properties-state-model';

const DEFAULT_STATE: AnalyticsUserSettingPropertiesStateModel = {
    'Default metrics': '',
    'Default currency': '',
};

@State<AnalyticsUserSettingPropertiesStateModel>({
    name: 'analyticsUserSettingProperties',
    defaults: DEFAULT_STATE,
})
@Injectable()
export class AnalyticsUserSettingPropertiesState {
    @Selector()
    static getProperties(state: AnalyticsUserSettingPropertiesStateModel) {
        return state;
    }

    @Action(SetAnalyticsUserSettingPropertiesMetrics)
    setUserSettingPropertiesMetrics(
        ctx: StateContext<AnalyticsUserSettingPropertiesStateModel>,
        action: SetAnalyticsUserSettingPropertiesMetrics,
    ) {
        const state = ctx.getState();

        ctx.patchState({
            ...state,
            'Default metrics': `${AnalyticsGeneralPropertiesHelpers.metricSignMap[action.payload]} ${action.payload}`,
        });
    }

    @Action(SetAnalyticsUserSettingPropertiesCurrency)
    setUserSettingPropertiesCurrency(
        ctx: StateContext<AnalyticsUserSettingPropertiesStateModel>,
        action: SetAnalyticsUserSettingPropertiesCurrency,
    ) {
        const state = ctx.getState();

        ctx.patchState({
            ...state,
            'Default currency': `${action.payload.symbol} - ${action.payload.name}`,
        });
    }
}
